import { formatDate } from '@dynatrace-sdk/units';

import { useSelectYear } from '../hooks/useSelectYear.js';

/**
 * SelectYearLabel component
 * Renders the formatted label for the select year view
 */
export const SelectYearLabel = () => {
  const { rangeStart, rangeEnd } = useSelectYear();

  return (
    <span>
      {formatDate(rangeStart, { year: 'numeric' })}
      &nbsp;-&nbsp;
      {formatDate(rangeEnd, { year: 'numeric' })}
    </span>
  );
};
SelectYearLabel['displayName'] = 'SelectYearLabel';
